import { ShieldCheck, Lock, Plane, BadgeCheck } from "lucide-react";
import { COMPLIANCE } from "../mock";
import { useReveal } from "../hooks/useReveal";

const ICONS = { ShieldCheck, Lock, Plane };

const ComplianceCard = ({ item, idx }) => {
  const Icon = ICONS[item.icon] || ShieldCheck;
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`compliance-${item.code.toLowerCase()}`}
      className="reveal group relative bg-[#121A33]/50 backdrop-blur-sm border border-[#2A3451] hover:border-[#C19A5D]/60 transition-all duration-500 p-8 sm:p-10"
      style={{ transitionDelay: `${idx * 80}ms` }}
    >
      <span className="absolute top-0 left-0 h-3 w-3 border-t border-l border-[#C19A5D]/0 group-hover:border-[#C19A5D] transition-colors duration-500" />
      <span className="absolute bottom-0 right-0 h-3 w-3 border-b border-r border-[#C19A5D]/0 group-hover:border-[#C19A5D] transition-colors duration-500" />

      <div className="flex items-start justify-between mb-6">
        <div>
          <div className="overline text-[10px]">{item.region}</div>
          <h3 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-2">
            <span className="gold-text">{item.code}</span>
          </h3>
          <div className="text-sm text-white/55 mt-1 font-body">{item.name}</div>
        </div>
        <div className="h-12 w-12 border border-[#C19A5D]/40 bg-[#0A1128] flex items-center justify-center shrink-0">
          <Icon className="h-5 w-5 text-[#C19A5D]" strokeWidth={1.25} />
        </div>
      </div>

      <p className="text-sm sm:text-base text-white/70 font-body leading-relaxed">
        {item.summary}
      </p>
    </div>
  );
};

export const Compliance = () => {
  const ref = useReveal();
  return (
    <section
      id="compliance"
      data-testid="compliance-section"
      className="relative py-28 lg:py-32 bg-[#0A1128]/40 border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div ref={ref} className="reveal max-w-3xl mb-16">
          <span className="overline">Regulatory & compliance</span>
          <h2 className="font-heading mt-4 text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.05]">
            Engineered for the
            <br />
            <span className="gold-text">Kingdom of Saudi Arabia.</span>
          </h2>
          <p className="mt-6 text-white/65 text-lg leading-relaxed">
            OmniLink is designed to align with the regulatory and cybersecurity frameworks that
            govern aviation operations in the Kingdom of Saudi Arabia — from civil aviation
            authority requirements to critical-systems cybersecurity controls.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {COMPLIANCE.map((item, i) => (
            <ComplianceCard key={item.code} item={item} idx={i} />
          ))}
        </div>

        <div className="mt-10 flex items-start gap-3 text-xs text-white/45 max-w-3xl">
          <BadgeCheck className="h-4 w-4 text-[#C19A5D] mt-0.5 shrink-0" strokeWidth={1.5} />
          <span>
            Compliance posture is continuously reviewed against the latest published guidance
            from the relevant authority. Final certification status depends on the deployment
            configuration and customer environment.
          </span>
        </div>
      </div>
    </section>
  );
};
